<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="component-chat-log" class="m-8" v-if="chatData">
        <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">

            <!-- If previous msg is older than current time -->
            <template v-if="chatData[index-1]">
                <vs-divider v-if="!isSameDay(msg.sendAt, chatData[index-1].sendAt)" class="msg-time">
                    <span>{{ toDate(msg.sendAt) }}</span>
                </vs-divider>
                <div class="spacer mt-8"
                     v-if="msg.senderUsername !== chatData[index-1].senderUsername"></div>
            </template>

            <div class="flex items-start" :class="[{'flex-row-reverse' : userInfo.username === msg.senderUsername}]">

                <template v-if="chatData[index-1]">
                    <template
                        v-if="(!hasSentPreviousMsg(chatData[index-1].isSent, userInfo.username === msg.senderUsername) || !isSameDay(msg.sendAt, chatData[index-1].sendAt))">
                        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                                   :class="userInfo.username === msg.senderUsername ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
                                   :src="msg.senderAvatar"></vs-avatar>
                    </template>
                </template>

                <template v-if="index == 0">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                               :class="userInfo.username === msg.senderUsername ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
                               :src="msg.senderAvatar"></vs-avatar>
                </template>

                <template v-if="chatData[index-1]">
                    <div class="mr-16"
                         v-if="!(!hasSentPreviousMsg(chatData[index-1].isSent, userInfo.username === msg.senderUsername) || !isSameDay(msg.sendAt, chatData[index-1].sendAt))"></div>
                </template>

                <div>
                    <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
                         v-if="msg.text.length > 0"
                         :class="{'bg-white': userInfo.username === msg.senderUsername, 'border border-solid border-grey-light bg-white': userInfo.username !== msg.senderUsername}">
                        <span>{{ msg.text }}</span>
                    </div>
                    <div class="msg break-words relative shadow-md rounded py-3 px-4 rounded-lg max-w-sm"
                         v-if="msg.customJson && msg.customJson.length > 0"
                         :class="{'bg-white float-right': userInfo.username === msg.senderUsername, 'border border-solid border-grey-light bg-white': userInfo.username !== msg.senderUsername}">
                        <div class="flex flex-wrap gap-2">
                            <div v-for="(media, indMedia) in msg.customJson" :key="indMedia">
                                <img class="img_msg cursor-pointer" :src="media.imageUrl" alt=""
                                     @click="openGallery(msg.customJson, indMedia)" v-if="media.fileType !== 4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                     viewBox="0 0 24 24" fill="none" v-if="media.fileType === 2"
                                     class="icon_play_in_chat cursor-pointer"
                                     @click="openGallery(msg.customJson, indMedia)">
                                    <circle cx="12" cy="12" r="10" stroke="#F8F8F8" stroke-width="1.5"/>
                                    <path
                                        d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
                                        stroke="#F8F8F8" stroke-width="1.5"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     height="60px" width="60px" version="1.1" id="_x36_" viewBox="0 0 512 512"
                                     xml:space="preserve" v-if="media.fileType === 4" class="-mr-2 cursor-pointer" @click="viewOrDownloadFile(media)">
<g>
	<g>
		<g>
			<path style="fill:#6AB5D3;"
                  d="M431.953,50.012V461.94c0,27.547-22.512,50.06-50.06,50.06H50.016     c-1.526,0-3.053-0.076-4.502-0.229c-1.526-0.076-2.976-0.305-4.426-0.61c-0.763-0.076-1.526-0.229-2.213-0.458     c-4.197-0.916-8.241-2.442-11.905-4.426c-0.076,0-0.076-0.076-0.076-0.076c-0.229-0.076-0.458-0.153-0.611-0.305     c-1.45-0.764-2.824-1.603-4.121-2.519c-1.602-0.992-3.129-2.137-4.502-3.434c-0.992-0.764-1.908-1.679-2.823-2.595     c-1.755-1.679-3.358-3.586-4.808-5.571c-0.458-0.61-0.916-1.297-1.374-1.908c-1.068-1.526-2.061-3.128-2.823-4.731     c-0.763-1.298-1.374-2.671-1.908-4.044c-0.611-1.374-1.145-2.824-1.603-4.35c-0.381-0.992-0.611-1.908-0.839-2.976     c-0.229-0.839-0.458-1.755-0.611-2.671c-0.153-0.764-0.229-1.602-0.381-2.366c0-0.153-0.076-0.306-0.076-0.457     c-0.229-2.061-0.381-4.198-0.381-6.333V179.36L179.363,0.028h202.53c5.876,0,11.523,0.991,16.712,2.975     c14.194,4.961,25.412,16.255,30.372,30.372c0.992,2.443,1.679,4.961,2.137,7.556c0.305,1.449,0.458,2.976,0.611,4.426     C431.877,46.882,431.953,48.486,431.953,50.012z"/>
            <path style="fill:#4884B9;" d="M129.306,179.348c27.523,0,50.042-22.519,50.042-50.042V0L0,179.348H129.306z"/>
		</g>
        <path style="opacity:0.06;fill:#040000;"
              d="M431.953,50.012V461.94c0,27.547-22.512,50.06-50.06,50.06H50.016    c-1.526,0-3.053-0.076-4.502-0.229c-1.526-0.076-2.976-0.305-4.426-0.61c-0.763-0.076-1.526-0.229-2.213-0.458    c-4.197-0.916-8.241-2.442-11.905-4.426c-0.076,0-0.076-0.076-0.076-0.076c-0.229-0.076-0.458-0.153-0.611-0.305    c-1.45-0.764-2.824-1.603-4.121-2.519c-1.602-0.992-3.129-2.137-4.502-3.434c-0.992-0.764-1.908-1.679-2.823-2.595    c-1.755-1.679-3.358-3.586-4.808-5.571c-0.458-0.61-0.916-1.297-1.374-1.908c-1.068-1.526-2.061-3.128-2.823-4.731    c-0.763-1.298-1.374-2.671-1.908-4.044c-0.611-1.374-1.145-2.824-1.603-4.35c-0.381-0.992-0.611-1.908-0.839-2.976    c-0.229-0.839-0.458-1.755-0.611-2.671l204.362-204.362l11.752-11.676l9.92-9.996h0.076L431.114,40.931    c0.305,1.449,0.458,2.976,0.611,4.426C431.877,46.882,431.953,48.486,431.953,50.012z"/>
	</g>
    <path style="opacity:0.1;fill:#040000;"
          d="M431.495,447.898v11.294c0,27.473-22.512,49.984-49.984,49.984H49.634   c-10.989,0-21.215-3.586-29.456-9.692c-4.273-3.053-7.937-6.792-11.065-11.065c-3.739-5.19-6.563-11.066-8.089-17.476   c-0.229-0.688-0.381-1.449-0.534-2.213c0-0.153-0.076-0.306-0.076-0.457l2.518-2.441c0.305,0.762,0.611,1.526,0.916,2.289   c7.86,17.475,25.488,29.838,45.787,29.838h331.878C408.984,497.959,431.495,475.447,431.495,447.898z"/>
</g>
</svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isPreview">
            <div class="preview-media">
                <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor"
                     stroke-width="2" fill="none"
                     stroke-linecap="round" stroke-linejoin="round"
                     class="css-i6dzq1 cursor-pointer" @click="preVideo"
                     v-if="isShowMedia & media.length > 1">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                <img v-if="isShowMedia && mediaPreview.fileType === 1"
                     :src="mediaPreview.imageUrl"
                     alt="">
                <video id="video-play" controls autoplay
                       v-if="isShowMedia && mediaPreview.fileType === 2">
                    <source :src="mediaPreview.videoUrl" type="video/mp4">
                </video>
                <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor"
                     stroke-width="2" fill="none"
                     stroke-linecap="round" stroke-linejoin="round"
                     class="css-i6dzq1 cursor-pointer" @click="nextVideo"
                     v-if="isShowMedia & media.length > 1">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </div>
            <div class="button-close-preview flex justify-end">
                <svg viewBox="0 0 24 24" width="26" height="26" stroke="currentColor"
                     stroke-width="2" fill="none"
                     stroke-linecap="round" stroke-linejoin="round"
                     class="css-i6dzq1 cursor-pointer"
                     @click="closePreview">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: Number,
            required: true,
        },
        chatData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            mediaPreview: null,
            isPreview: false,
            isShowMedia: false,
            indMedia: null,
            media: [],
        }
    },
    computed: {
        activeUserImg() {
            return this.$store.state.AppActiveUser.photoURL;
        },
        senderImg() {
            return (isSentByActiveUser) => {
                if (isSentByActiveUser) return this.$store.state.AppActiveUser.photoURL
                else return this.$store.getters['chat/contact'](this.userId).photoURL
            }
        },
        hasSentPreviousMsg() {
            return (last_sender, current_sender) => last_sender === current_sender
        },
    },
    methods: {
        isSameDay(time_to, time_from) {
            const date_time_to = new Date(Date.parse(time_to))
            const date_time_from = new Date(Date.parse(time_from));
            return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate();
        },
        toDate(time) {
            const locale = "vn-vi";
            const date_obj = new Date(Date.parse(time));
            const monthName = date_obj.toLocaleString(locale, {
                month: 'short'
            });
            return date_obj.getDate() + ' ' + monthName;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
            });
        },

        viewOrDownloadFile(file) {
            window.open(file.fileUrl, "_blank");
        },

        openGallery(viv, index) {
            this.media = [];
            this.indMedia = index
            this.media = viv;
            this.mediaPreview = this.media[index]
            this.isPreview = true;
            this.isShowMedia = true;
        },

        closePreview() {
            this.isPreview = false;
            this.isShowMedia = false;
            this.media = [];
        },

        nextVideo() {
            this.isShowMedia = false;
            let checkLength = this.media.length
            this.indMedia = this.indMedia + 1;
            if (this.indMedia + 1 > checkLength) this.indMedia = 0;
            this.mediaPreview = this.media[this.indMedia];
            setTimeout(() => {
                this.isShowMedia = true;
            }, 1)
        },

        preVideo() {
            this.isShowMedia = false;
            if (this.indMedia === 0) {
                this.indMedia = this.media.length - 1;
            } else {
                this.indMedia = this.indMedia - 1;
            }
            this.mediaPreview = this.media[this.indMedia];
            setTimeout(() => {
                this.isShowMedia = true;
            }, 1)
        },
    },
    updated() {
        this.scrollToBottom();
    },
    mounted() {
        this.scrollToBottom();
    },
}
</script>

<style lang="scss">
.img_msg {
    width: 6.5rem;
    height: 6.5rem;
    object-fit: cover;
    object-position: center;
}

@media (min-width: 1200px) {
    .preview-media,
    .button-close-preview {
        //margin-left: 260px !important;
        //width: calc(100% - 260px) !important;
    }
}

@media (max-width: 1199px) {
    .preview-media,
    .button-close-preview {
        margin-left: 0 !important;
        width: 100% !important;
    }
}

.preview-media {
    left: 0;
    background-color: rgba(0, 0, 0, .8);
    padding: 10px 20px 10px 10px;
    -webkit-transition: opacity .3s ease;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    z-index: 99999;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    //box-align: center;
    //box-pack: center;
    transition: opacity .3s ease;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    video, img {
        max-height: calc(100vh);
        cursor: pointer;
        display: block;
        height: 100%;
        margin: 0 auto;
        max-width: 90%;
        -webkit-user-select: none;
        padding-top: 62px !important;
    }
}

.button-close-preview {
    left: 0;
    padding: 10px 20px 10px 10px;
    -webkit-transition: opacity .3s ease;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    z-index: 99999;
    top: 62px;
    width: 100%;
    height: 62px;
    transition: opacity .3s ease;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.icon_play_in_chat {
    position: absolute;
    left: 40%;
    top: 35%;
}
</style>
